import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { ISuperTableSegment } from '@modeso/types__aumico-lib-notes-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ISuperTableCreateSegmentDialogResult } from '../../interfaces/super-table-create-segment-dialog-result.interface';

@UntilDestroy()
@Component({
    selector: 'super-table-create-segment-form',
    templateUrl: './super-table-create-segment-form.dialog.html',
    styleUrls: ['./super-table-create-segment-form.dialog.scss'],
})
export class SuperTableCreateSegmentDialogComponent implements OnInit {
    public form: UntypedFormGroup | undefined;
    public initialSelectedColumns: INameId[] = [];
    @Input() columnSelectionOptions: INameId[] = [];
    @Input() segmentToEdit: ISuperTableSegment | null = null;
    @Input() language = 'de-ch';
    @Output() formValueChange = new EventEmitter<ISuperTableCreateSegmentDialogResult>();

    ngOnInit(): void {
        this.initializeForm();
    }

    private initializeForm(): void {
        let title: string | undefined;
        this.initialSelectedColumns = [];

        if (this.segmentToEdit) {
            title = this.segmentToEdit.title?.[this.language];
            this.initialSelectedColumns =
                this.columnSelectionOptions.filter((option) =>
                    (this.segmentToEdit.childColIds ?? []).includes(option.id),
                ) || [];
        }

        this.form = new UntypedFormGroup({
            title: new UntypedFormControl(title),
            columns: new UntypedFormControl(this.initialSelectedColumns),
        });

        this.form.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
            const result: ISuperTableCreateSegmentDialogResult = {
                segmentTitle: this.form?.get('title')?.value,
                selectedColumns: this.form?.get('columns')?.value,
            };

            this.formValueChange.emit(result);
        });
    }
}
